import PropTypes from 'prop-types';

import { ALTERNATIVE_TYPE } from '@/common/constants';
import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const contAlternativeProductDefaultProps = {
  ...ClassNameDefaultProps,
  name: '',
};

export const contAlternativeProductPropTypes = {
  ...ClassNamePropTypes,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  type: PropTypes.oneOf([ALTERNATIVE_TYPE.SUBSTITUTE, ALTERNATIVE_TYPE.DIFF])
    .isRequired,
  url: PropTypes.string.isRequired,
};
